const oesa = {
  siegel: [],
  summingup: {
    fahrrad: 'Fahrrad-Diebstahl',
    notfall: 'ServiceSchutzbrief',
  },
  prepage: {
    leistungen: [
      'Absicherung Ihrer Einrichtung',
      'Ersatz des Hausrates zum Neuwert',
      'Einfach erweiterbar durch zusätzliche Bausteine',
    ],
  },
  erstedaten: {
    headline: 'In wenigen Schritten zu Ihrer Hausratversicherung',
    wohnflaeche_tt: `<h4>Wohnfläche</h4>
        <p>Anhand der Wohnfläche berechnen wir Ihre Versiche&shy;rungs&shy;summe.</p>
        <p>Hierfür wird ein Wert von 700 EUR/m² angesetzt.</p>`,
  },
  produktvergleich: {
    Basis: {
      label: 'Basis',
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h4>Wertsachen</h4>
          <ul class="list-icn-checkbullet">
          <li>Wertsachen sind insgesamt bis zu einer Höhe von 20&nbsp;% der Versicherungssumme mitversichert.*</li>
          <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 1.000&nbsp;€ versichert.</li>
          <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 2.500&nbsp€ versichert.</li>
          <li>Schmucksachen, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold 
          oder Platin sind bis maximal 20.000&nbsp;€ versichert.</li>
          </ul>
          <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
            $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_zusatz)
          </p>
          $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p class="mini">
          Bitte sprechen Sie <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">uns an</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind, als 20&nbsp;% Ihrer Versicherungssumme.</p>`,
        wertsachen_footer_spk: '<p class="mini">Bei Fragen wenden Sie sich bitte an Ihren Sparkassenberater.</p>',
      },
      leistungenTooltips: {
        aussen: `<h4>Außenversicherung bis 10.000&nbsp€</h4>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend (maximal 3 Monate) außerhalb des 
        Versicherungsortes – also der versicherten Wohnung oder des Hauses – befinden.</p>
        <p>Wir erstatten bis zu 10&nbsp;% der Versicherungssumme, maximal 10.000&nbsp;€.</p>`,
        bargeld: `<h4>Bargeld unverschlossen bis 2.500&nbsp;€</h4>
        <p>Im Versicherungsschutz ist Ihr unverschlossenes Bar&shy;geld bis zu einer Summe von 2.500&nbsp;€ je 
        Vers&shy;icher&shy;ungs&shy;fall mit inbegriffen. </p>`,
      },
      keineLeistungenTooltips: {
        regen: `<h4>Weitere Naturgefahren</h4>
        <p>Wir entschädigen den versicherten Hausrat, welcher durch die unmittelbare Einwirkung von:</p>
        <ul class="list-icn-checkbullet">
        <li>Überschwemmung,</li>
        <li>Rückstau,</li>
        <li>Erdbeben,</li>
        <li>Vulkanausbruch,</li>
        <li>Erdrutsch,</li>
        <li>Schneedruck und</li>
        <li>Lawinen</li>
        </ul>
        <p>zerstört oder beschädigt wird oder infolge eines solchen Ereignisses abhandenkommt.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrich&shy;tungs&shy;gegen&shy;stände, 
        Gebrauchsge&shy;genstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>
        <p>Die Entschädigung hierfür beschränkt sich bis 1.000&nbsp;€ je Versicherungsfall.</p>
        <p>Sollte die Entschädigungsgrenze zu gering sein, können Sie den Versicherungsumfang über den Baustein 
        "Schutz vor Naturgefahren" erweitern.</p>`,
        garten: `<h4>Diebstahl Gartenmöbel/-geräte</h4>
        <p>Im Falle der Entwendung durch Diebstahl entschädigen wir Ihnen</p>
        <ul class="list-icn-checkbullet">
        <li>Gartenmöbel/-geräte (inklusive Grillgeräten),</li>
        <li>Skulpturen u. a. Gartendekorationen,</li>
        <li>Spiel- und Sportgeräte,</li>
        <li>sowie Wäsche und Bekleidung</li>
        </ul>
        <p>außerhalb der Versicherungsräume auf dem eingefriedeten Grundstück.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 1.500&nbsp;€ begrenzt.</p>`,
        fahrlaessigkeit: `<h4>Grobe Fahrlässigkeit</h4>
        <p>Sie genießen auch dann noch Versicherungsschutz, wenn Sie den Schaden unachtsam selbst verursacht haben.</p>`,
      },
      leistungen: {
        feuer: 'Feuer',
        einbruch: 'Einbruchdiebstahl und Beraubung',
        hagel: 'Hagel',
        sturm: 'Sturm ab Windstärke 8',
        leitung: 'Leitungswasser',
        bargeld: 'Bargeld unverschlossen bis 2.500&nbsp;€',
        aussen: 'Außenversicherung bis 10.000&nbsp;€',
      },
      keineLeistungen: {
        regen: 'Erweiterte Naturgefahren',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit',
        garten: '<div class="mb-lg-4">Diebstahl Gartenmöbel/-geräte</div>',
        marder: 'Beschädigung durch Wildtiere',
        diebstahl: 'Diebstahl am Arbeitsplatz',
        haustiere: '<div class="mb-lg-4">Unterbringungskosten für Haustiere</div>',
      },
    },
    Komfort: {
      label: 'Komfort',
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h4>Wertsachen</h4>
        <ul class="list-icn-checkbullet">
        <li>Wertsachen sind insgesamt bis zu einer Höhe von 20&nbsp;% der Versicherungssumme mitversichert.*</li>
        <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 2.000&nbsp;€ versichert.</li>
        <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 2.500&nbsp;€ versichert.</li>
        <li>Schmucksachen, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold 
        oder Platin sind bis maximal 20.000&nbsp;€ versichert.</li>
        </ul>
        <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
            $t(produktvergleich.Basis.andereLeistungenTooltips.wertsachen_zusatz)
          </p>
          $t(produktvergleich.Komfort.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p class="mini">
          Bitte sprechen Sie <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">uns an</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind, als 20&nbsp;% Ihrer Versicherungssumme.</p>`,
        wertsachen_footer_spk: '<p class="mini">Bei Fragen wenden Sie sich bitte an Ihren Sparkassenberater.</p>',
      },
      leistungenTooltips: {
        aussen: `<h4>Außenversicherung bis 20.000&nbsp;€</h4>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend (maximal 6 Monate) außerhalb des 
        Versicherungsortes – also der versicherten Wohnung oder des Hauses – befinden.</p>
        <p>Wir erstatten bis zu 20&nbsp;% der Versicherungssumme, maximal 20.000&nbsp;€.</p>`,
        regen: `<h4>Weitere Naturgefahren bis 500&nbsp;€</h4>
        <p>Wir entschädigen den versicherten Hausrat, welcher durch die unmittelbare Einwirkung von:</p>
        <ul class="list-icn-checkbullet">
        <li>Überschwemmung,</li>
        <li>Rückstau,</li>
        <li>Erdbeben,</li>
        <li>Vulkanausbruch,</li>
        <li>Erdrutsch,</li>
        <li>Schneedruck und</li>
        <li>Lawinen</li>
        </ul>
        <p>zerstört oder beschädigt wird oder infolge eines solchen Ereignisses abhandenkommt.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrich&shy;tungs&shy;gegen&shy;stände, 
        Gebrauchsge&shy;genstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>
        <p>Die Entschädigung hierfür beschränkt sich bis 500&nbsp;€ je Versicherungsfall.</p>
        <p>Sollte die Entschädigungsgrenze zu gering sein, können Sie den Versicherungsumfang über den Baustein 
        "Schutz vor Naturgefahren" erweitern.</p>`,
        bargeld: `<h4>Bargeld unverschlossen bis 5.000&nbsp;€</h4>
        <p>Im Versicherungsschutz ist Ihr unverschlossenes Bar&shy;geld bis zu einer Summe von 5.000&nbsp;€ je 
        Vers&shy;icher&shy;ungs&shy;fall mit inbegriffen. </p>`,
        garten: `<h4>Diebstahl Gartenmöbel/-geräte bis 1.500&nbsp;€</h4>
        <p>Im Falle der Entwendung durch Diebstahl entschädigen wir Ihnen</p>
        <ul class="list-icn-checkbullet">
        <li>Gartenmöbel/-geräte (inklusive Grillgeräten),</li>
        <li>Skulpturen u.a. Gartendekorationen,</li>
        <li>Spiel- und Sportgeräte,</li>
        <li>sowie Wäsche und Bekleidung</li>
        </ul>
        <p>außerhalb der Versicherungsräume auf dem eingefriedeten Grundstück.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 1.500&nbsp;€ begrenzt.</p>`,
        fahrlaessigkeit: `<h4>Grobe Fahrlässigkeit bis 20.000&nbsp;€</h4>
        <p>Sie genießen auch dann noch Versicherungsschutz, wenn Sie den Schaden unachtsam selbst verursacht haben.</p>`,
      },
      leistungen: {
        feuer: 'Feuer',
        einbruch: 'Einbruchdiebstahl und Beraubung',
        hagel: 'Hagel',
        sturm: 'Sturm ab Windstärke 8',
        leitung: 'Leitungswasser',
        bargeld: 'Bargeld unverschlossen bis 5.000&nbsp;€',
        aussen: 'Außenversicherung bis 20.000&nbsp;€',
        regen: 'Erweiterte Naturgefahren bis 500&nbsp;€',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis 20.000&nbsp;€',
        garten: 'Diebstahl Gartenmöbel/-geräte bis 1.500&nbsp;€',
      },
      keineLeistungen: {
        marder: 'Beschädigung durch Wildtiere',
        diebstahl: 'Diebstahl am Arbeitsplatz',
        haustiere: '<div class="mb-lg-4">Unterbringungskosten für Haustiere</div>',
      },
      vsu_prozentsatz: '10',
    },
    Premium: {
      label: 'Premium',
      andereLeistungen: {
        vsu: 'Versicherungssumme {{VSU}}&nbsp;€',
        wertsachen: 'Wertsachen je nach Art bis zu {{WERT}}&nbsp;€',
      },
      andereLeistungenTooltips: {
        wertsachen: `<h4>Wertsachen</h4>
        <ul class="list-icn-checkbullet">
        <li>Wertsachen sind insgesamt bis zu einer Höhe von 30&nbsp;% der Versicherungssumme mitversichert.*</li>
        <li>Bargeld und auf Geldkarten geladene Beträge sind bis maximal 3.000&nbsp;€ versichert.</li>
        <li>Urkunden, Sparbücher und Wertpapiere sind bis maximal 2.500&nbsp;€ versichert.</li>
        <li>Schmucksachen, Edelsteine, Perlen, Briefmarken, Münzen und Medaillen sowie alle Sachen aus Gold 
        oder Platin sind bis maximal 20.000&nbsp;€ versichert.</li>
        </ul>
        <p class="mini">
            <strong>* Wenn die versicherte Summe zu niedrig ist, ersetzen wir Schäden nur anteilig!</strong>
            $t(produktvergleich.Premium.andereLeistungenTooltips.wertsachen_zusatz)
          </p>
          $t(produktvergleich.Premium.andereLeistungenTooltips.wertsachen_footer)`,
        wertsachen_footer: `<p class="mini">
          Bitte sprechen Sie <a data-tracking-name="kontaktformular" href=$t(footer.kontaktformular) target="_blank">uns an</a>, 
          falls Ihre Wertsachen in Summe mehr wert sind, als 30&nbsp;% Ihrer Versicherungssumme.</p>`,
        wertsachen_footer_spk: '<p class="mini">Bei Fragen wenden Sie sich bitte an Ihren Sparkassenberater.</p>',
      },
      leistungenTooltips: {
        aussen: `<h4>Außenversicherung bis 30.000&nbsp;€</h4>
        <p>Es besteht weltweiter Schutz für versicherte Sachen, die sich vorübergehend (maximal 12 Monate) außerhalb des 
        Versicherungsortes – also der versicherten Wohnung oder des Hauses – befinden.</p>
        <p>Wir erstatten bis zu 30&nbsp;% der Versicherungssumme, maximal 30.000&nbsp;€.</p>`,
        regen: `<h4>Weitere Naturgefahren bis 1.000&nbsp;€</h4>
        <p>Wir entschädigen den versicherten Hausrat, welcher durch die unmittelbare Einwirkung von:</p>
        <ul class="list-icn-checkbullet">
        <li>Überschwemmung,</li>
        <li>Rückstau,</li>
        <li>Erdbeben,</li>
        <li>Vulkanausbruch,</li>
        <li>Erdrutsch,</li>
        <li>Schneedruck und</li>
        <li>Lawinen</li>
        </ul>
        <p>zerstört oder beschädigt wird oder infolge eines solchen Ereignisses abhandenkommt.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrich&shy;tungs&shy;gegen&shy;stände, 
        Gebrauchsge&shy;genstände wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen.</p>
        <p>Die Entschädigung hierfür beschränkt sich bis 1.000&nbsp;€ je Versicherungsfall.</p>
        <p>Sollte die Entschädigungsgrenze zu gering sein, können Sie den Versicherungsumfang über den Baustein 
        "Schutz vor Naturgefahren" erweitern.</p>`,
        bargeld: `<h4>Bargeld unverschlossen bis 5.000&nbsp;€</h4>
        <p>Im Versicherungsschutz ist Ihr unverschlossenes Bar&shy;geld bis zu einer Summe von 5.000&nbsp;€ je 
        Vers&shy;icher&shy;ungs&shy;fall mit inbegriffen. </p>`,
        garten: `<h4>Diebstahl Gartenmöbel/-geräte bis 6.000&nbsp;€</h4>
        <p>Im Falle der Entwendung durch Diebstahl entschädigen wir Ihnen</p>
        <ul class="list-icn-checkbullet">
        <li>Gartenmöbel/-geräte (inklusive Grillgeräten),</li>
        <li>Skulpturen u.a. Gartendekorationen,</li>
        <li>Spiel- und Sportgeräte,</li>
        <li>sowie Wäsche und Bekleidung</li>
        </ul>
        <p>außerhalb der Versicherungsräume auf dem eingefriedeten Grundstück.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 6.000&nbsp;€ begrenzt.</p>`,
        sturm: `<h4>Sturm ab Windstärke 7</h4>
        <p>Versichert sind Schäden an Ihrem Hausrat durch Sturm ab Windstärke 7.</p>
        <p>Unter Hausrat versteht man den Inhalt Ihrer Wohnung oder Ihres Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände wie Kleidung, 
        aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen. </p>`,
        diebstahl: `<h4>Diebstahl am Arbeitsplatz bis 200&nbsp;€</h4>
        <p>Mitversichert ist der Diebstahl von versicherten Sachen (zum Beispiel Handtasche oder Portemonnaie) am Arbeitsplatz oder in der Universität.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 200&nbsp;€ begrenzt.</p>`,
        haustiere: `<h4>Unterbringungskosten für Haustieren bis 2.000&nbsp;€</h4>
        <p>Mitversichert ist die Unterbringung Ihrer versicherten Haustiere in Tierheimen oder Tierpensionen, wenn Ihre versicherte Wohnung aufgrund eines Schadenfalles unbewohnbar wurde.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 2.000&nbsp;€ begrenzt.</p>`,
        fahrlaessigkeit: `<h4>Grobe Fahrlässigkeit bis {{VSU}}&nbsp;€</h4>
        <p>Sie genießen auch dann noch Versicherungsschutz, wenn Sie den Schaden unachtsam selbst verursacht haben.</p>`,
      },
      leistungen: {
        feuer: 'Feuer',
        einbruch: 'Einbruchdiebstahl und Beraubung',
        hagel: 'Hagel',
        sturm: 'Sturm ab Windstärke 7',
        leitung: 'Leitungswasser',
        bargeld: 'Bargeld unverschlossen bis 5.000&nbsp;€',
        aussen: 'Außenversicherung bis 30.000&nbsp;€',
        regen: 'Erweiterte Naturgefahren bis 1.000&nbsp;€',
        fahrlaessigkeit: 'Grobe Fahrlässigkeit bis {{VSU}}&nbsp;€',
        garten: 'Diebstahl Gartenmöbel/-geräte bis 6.000&nbsp;€',
        marder: 'Beschädigung durch Wildtiere 10.000&nbsp;€',
        diebstahl: 'Diebstahl am Arbeitsplatz bis 200&nbsp;€',
        haustiere: 'Unterbringungskosten für Haustiere bis 2.000&nbsp;€',
      },
      vsu_prozentsatz: '20',
    },
    produkte: {
      vsu_flaeche: '700',
      feuer: `<h4>Feuer</h4>
        <p>Versichert sind Hausratschäden durch Feuer (Brand, Blitzschlag, Explosion, Implosion, Anprall von Fahrzeugen).</p>
        <p>Ab Hausrat-Komfort sind zusätzlich Schäden durch Verpuffung, Rauch und Ruß mitversichert.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrich&shy;tungs&shy;gegen&shy;stände, 
        Gebrau&shy;chs&shy;gegenstände wie Kleidung, aber auch Ver&shy;brauchs&shy;güter (zum Beispiel Essen) und Wer&shy;tsachen.</p>`,
      leitung: `<h4>Leitungswasser</h4>
        <p>Versichert sind Schäden an Ihrem Hausrat durch Leitungswasser – zum Beispiel, wenn nach einem Rohrbruch Ihr Haus unter Wasser steht.</p>
        <p>Unter Hausrat versteht man den Inhalt der Wohnung oder des Hauses. Zu ihm zählen Einrichtungs&shy;gegen&shy;stände, 
        Gebrauchs&shy;gegenstände wie Kleidung, aber auch Verbrauchs&shy;güter (zum Beispiel Essen) und Wertsachen.</p>`,
      marder: `<h4>Beschädigung durch Wildtiere</h4>
        <p>Schäden an Ihrem versicherten Hausrat durch Wildtiere erstatten wir mit bis zu 10.000&nbsp;€ je Versicherungsjahr.</p>
        <p>Unter Hausrat versteht man den Inhalt Ihrer Wohnung oder Ihres Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände 
        wie Kleidung, aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen. </p>`,
      sturm: `<h4>Sturm ab Windstärke 8</h4>
        <p>Versichert sind Schäden an Ihrem Hausrat durch Sturm ab Windstärke 8.</p>
        <p>Unter Hausrat versteht man den Inhalt Ihrer Wohnung oder Ihres Hauses. Zu ihm zählen Einrichtungsgegenstände, Gebrauchsgegenstände wie Kleidung, 
        aber auch Verbrauchsgüter (zum Beispiel Essen) und Wertsachen. </p>`,
      diebstahl: `<h4>Diebstahl am Arbeitsplatz</h4>
        <p>Mitversichert ist der Diebstahl von versicherten Sachen (zum Beispiel Handtasche oder Portemonnaie) am Arbeitsplatz oder in der Universität.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 200&nbsp;€ begrenzt.</p>`,
      haustiere: `<h4>Unterbringungskosten für Haustieren</h4>
        <p>Mitversichert ist die Unterbringung Ihrer versicherten Haustiere in Tierheimen oder Tierpensionen, wenn Ihre versicherte Wohnung aufgrund eines Schadenfalles unbewohnbar wurde.</p>
        <p>Die Entschädigung ist je Versicherungsfall auf 2.000&nbsp;€ begrenzt.</p>`,
    },
    zusatz: {
      notfalldienste: 'ServiceSchutzbrief Haus & Wohnung',
      notfalldienste_tt: `<h4>ServiceSchutzbrief für Haus & Wohnung</h4>
        <p>Ihre Heizung ist kalt, Sie haben den Schlüssel verloren oder ein Wespenvolk hat sich auf Ihrem Balkon 
        einge&shy;nistet? Kleine Ärgernisse kosten viel Zeit, Geld und Nerven. 
        Mit dem ServiceSchutzbrief für Haus & Woh&shy;nung sind die Kosten für Notdienst- und Hand&shy;werk&shy;er&shy;leistungen 
        bei einem Notfall abgedeckt.</p>
        <p>Je Versicherungsfall erstatten wir bis zu 400&nbsp;€ und maximal 1.000&nbsp;€ für alle Versicherungsfälle im Versicherungsjahr.</p>`,
      naturgefahren_beschreibung: `
        <p class="mb-2">Zum Schutz bei Elementar­schäden wie Stark­regen, Hoch­wasser oder Schnee­druck.</p>
        <ul class="list-icn-checkbullet">
            <li>500&nbsp;€ Selbstbeteiligung allgemein</li>
        </ul>`,
      naturgefahren_sb_tt: `<h4>Selbstbeteiligung für Überschwemmung</h4>
      <p>Wenn Sie eine höhere Selbstbeteiligung (SB) für Elementarschäden vereinbaren, müssen Sie im Schadenfall einen Teil der Kosten selbst bezahlen
       – aber nur bis zur Höhe der vereinbarten SB.</p>
      <p>Je höher die SB, desto geringer ist Ihr Beitrag.</p>
      <p><strong>Hinweis:</strong> Die hier ausgewählte SB gilt nur für Schäden durch Überschwemmung und muss mindestens erbracht werden. Wurde für 
      die gesamte Hausratversicherung eine höhere SB vereinbart, gilt diese.</p>`,
      naturgefahren_tt: `<h4>Schutz vor Naturgefahren</h4>
        <p>Naturgefahren gehören leider fast schon zur Tagesordnung – auch in unseren Breitengraden. Dabei machen Hochwasser oder 
        Schnee vor Ihrer Türschwelle nicht halt. Aus diesem Grund empfehlen wir Ihnen die Absicherung gegen Elementarschäden 
        (erweiterte Naturgefahren). Mit diesem Zusatzbaustein erhalten Sie wetterfesten Schutz vom Keller bis zum Dach vor:</p>
        <ul class="list-icn-checkbullet">
          <li>Überschwemmung,</li>
          <li>Rückstau,</li>
          <li>Erdbeben,</li>
          <li>Vulkanausbruch,</li>
          <li>Erdrutsch,</li>
          <li>Schneedruck und</li>
          <li>Lawinen.</li>
        </ul>`,
      naturgefahren_alert_gk0: '<p>Für Ihre Adresse können wir den Preis nicht exakt bestimmen. Hier ist eine persönliche Beratung notwendig. '
        + 'Bitte wenden Sie sich an Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk4: '<p>Ihre Adresse befindet sich in einem Risikogebiet. Hier ist eine persönliche Beratung notwendig. '
        + 'Bitte wenden Sie sich an Ihren Ansprechpartner <a data-tracking-name="beratersuche" href=$t(beratersuche) target="_blank">vor Ort</a>.</p>',
      naturgefahren_alert_gk0_stat: `
      <p>Die Elementarzonenprüfung ist nicht möglich. Entweder ist die Wagnisanschrift nicht korrekt oder 
      liegt außerhalb des Zonierungsbereiches. Bitte wenden Sie sich daher für eine exakte Beitragskalkulation an Ihre Fachabteilung.</p>
      `,
      naturgefahren_alert_gk23_stat: '<p>Das Ergebnis der Zonenprüfung mit ZÜRS macht eine'
        + ' erneute'
        + ' Prüfung der Zone bei Policierung des Antrages erforderlich. Hier kann es zu Rückfragen'
        + ' durch den Fachbereich kommen.</p>',
      naturgefahren_alert_gk4_stat: `
      <p>Das Elementarschadenrisiko des eingegebenen Versicherungsortes ist möglicherweise sehr hoch. 
      Deshalb ist eine individuelle Beratung wichtig und eine Berechnung hier nicht möglich.</p>
      `,
      fahrraddiebstahl_title: 'Fahrrad-Diebstahl einschließen',
      fahrraddiebstahl_tt: `<h4>Fahrrad-Diebstahl</h4>
        <p>Sie lieben Ihr Fahrrad? Mit dem Zusatzbaustein "Fahrrad-Diebstahl" kann Ihre Hausratversicherung auf 
        Fahrrad-Diebstahlschäden ausgedehnt werden. Hierin enthalten sind alle Fahrräder, Fahrradanhänger und Fahrräder 
        mit Elektromotor, die nicht der Zulassungs&shy;pflicht unterliegen.</p> 
        <p>Der Versiche&shy;rungs&shy;schutz besteht rund um die Uhr an jedem Ort.</p>
        <p>Der Versiche&shy;rungs&shy;umfang beläuft sich prozentual auf die gesamte Versiche&shy;rungs&shy;summe Ihrer Hausrat&shy;ver&shy;sicherung. 
        Sie können diese Leistungs&shy;erweiterung mit maximal 9,0&nbsp;% der Versiche&shy;rungs&shy;summe abschlie&shy;ßen.</p>`,
      florianrabatt_tt: `<h4>Florianrabatt</h4>
        <p>Für Mitglieder der Feuerwehr, die eine ÖSA-FeuerwehrRente abgeschlossen oder beantragt haben, gibt es 
        20 % zusätzlichen Rabatt.</p>`,
      florianrabatt_beschreibung: 'Für Besitzer der ÖSA-FeuerwehrRente',
      nberabatt_tt: `<h4>Rabatt bei positiver NBE</h4>
        <p>Bei einer positiven Nettobestandsentwicklung kann ein zusätzlicher Rabatt in Höhe von 10 % vergeben werden.</p>`,
      nberabatt_beschreibung: 'Hinweis: Bitte prüfen Sie, ob die Berechtigung der ÖSA vorhanden ist!',
      zielgruppenrabatt_tt: `<h4>Zielgruppenrabatt</h4>
        <p>Versicherungsnehmern ab dem vollendeten 45. Lebensjahr kann bei Vertragsabschluss ein Sonderrabatt von 10&nbsp;%, 
        ab dem 55. Lebensjahr ein Sonderrabatt von 20&nbsp;% gewährt werden.</p>`,
      zielgruppenrabatt_beschreibung: 'Für Kunden ab dem vollendeten 45. Lebensjahr.',
      notfalldienste_beschreibung: 'Wir zahlen Ihren Schlüsseldienst und andere Handwerkerrechnungen.',
    },
    sb_tt: `<h4>Selbstbeteiligung Hausratversicherung</h4>
      <p>Wenn Sie eine Selbstbeteiligung (SB) vereinbaren, müssen Sie im Schadenfall einen Teil der Kosten selbst bezahlen – aber nur bis zur Höhe der vereinbarten SB.</p>
      <p>Je höher die SB, desto geringer ist Ihr Beitrag.</p>
      <p>Die hier ausgewählte SB gilt nur für die Hausratversicherung.</p>
      <p>Für die Glasversicherung, Fahrrad-Diebstahlversicherung und den ServiceSchutzbrief Haus & Wohnung gelten keine Selbstbeteiligungen.</p>`,
    sb_1000_alert: `
      <p>
        <strong>Bitte beachten Sie:</strong> Ab einer Selbstbeteiligung von 1.000 € erhöht sich auch die SB für den Baustein "Schutz vor Naturgefahren".
      </p>
    `,
    links: {
      leistungsuebersichtLink: 'https://www.oesa.de/hausrat_leistungsuebersicht',
      infoBlattLink: 'https://www.oesa.de/hausrat_produktinformation',
      infoBlattGlasLink: 'https://www.oesa.de/haushalt_glas_produktinformation',
      versBedingungenLink: 'https://www.oesa.de/hausrat_versicherungsbedingungen',
      versBedingungenGlasLink: 'https://www.oesa.de/haushalt_glas_versicherungsbedingungen',
    },
    laufzeit_alert: '<p>Wenn das Beschäftigungsverhältnis "öffentlicher Dienst ohne Service" ausgewählt ist, darf die '
        + 'Vertragslaufzeit 1 Jahr nicht überschreiten.</p>',
  },
  zahlungsdaten: {
    zahlart_alert: 'Beim Tarif Öffentlicher Dienst ohne Service ist die Zahlung nur per Lastschrift möglich.',
  },
  beantragen: {
    warenkorb: {
      notfalldienst: 'ServiceSchutzbrief Haus & Wohnung',
    },
  },
  abschluss: {
    fragen: 'Sie haben Fragen? Gerne hilft Ihnen auch unser Vertragsservice unter der'
      + ' Telefonnummer $t(abschluss.telefon).',
  },
};

export default oesa;
